/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Button } from './Button';
import './TFabout.css';
import { Link } from 'react-router-dom';

function TFabout() {
    const [button, setButton] = useState(true);
        
    const showButton = () => {
        if(window.innerWidth <= 960) {
            setButton(false);
        } else {
            setButton(true);
        }
    };
    
    useEffect ( ( ) => {
        showButton();
    }, []);

    window.addEventListener('resize', showButton);

    return (
        <div className = 'tfabout'>
            <div className = 'tfabout-container'>
				<div className = 'tfaboutcol-full'>
                    <Link data-aos='fade-up' data-aos-duration="1500" exact to="/Projects"><p>< img src="../Arrow2_One5Digital.png" alt="Loading..." / > BACK TO PROJECTS</p></Link>
                    <h1 data-aos='fade-up' data-aos-duration="1500">TIFFANY SHEN</h1>
                </div>
                <div className = 'tfaboutcol-left'>
                    <h3 data-aos='fade-up' data-aos-duration="1500">ABOUT CLIENT</h3>
                    <p data-aos='fade-up' data-aos-duration="1500" className = 'tfabout-desc'>Miss Tiffany Shen is the proud winner of Miss Australia International 2020. This is a 
                    worldwide movement that recognizes and celebrates women whose voices strive to make a difference.</p>
                    <h3 data-aos='fade-up' data-aos-duration="1500">SERVICE</h3>
                    <div data-aos='fade-up' data-aos-duration="1500" className="ser-wrapper">
                        <ul className="ser-1">
                            <li>Digital Strategy</li>
                            <li>Web Design</li>
                            <li>Branding</li>
                        </ul>
                        <ul className="ser-2">
                            <li>Development</li>
                            <li>User Experience</li>
                            <li>Enterprise UX</li>
                        </ul>
                    </div>
                    <h3 data-aos='fade-up' data-aos-duration="1500" className="year">YEAR</h3>
                    <p data-aos='fade-up' data-aos-duration="1500">2020</p>
                    <div data-aos='fade-up' data-aos-duration="1500" className='tfabout-btn'>
                        <a href="https://misstiffanyshen.com/" target="blank">
                            <Button className='btn' buttonStyle='btn--primary'>Visit Website</Button>
                        </a>
                    </div>
                </div>
                <div data-aos='fade-up' data-aos-duration="1500" className="tfaboutcol-right">
                    <img className="tfimg" src= "./MissTiffanyAbout_One5Digital.png" alt= "Loading..." />
                    <img className="tfimg2" src= "./MissTiffanyAbout_One5Digital.png" alt= "Loading..." />
                </div>
            </div>
        </div>
    )
}

export default TFabout
